
<template>
  <div id="app">
    <!-- <Layout /> -->
    <Router-view></Router-view>
    <!-- <map1> </map1> -->
  </div>
</template>

<script>
import Layout from "./views/Layout/Index.vue";
import map1 from "./views/Home/WorldMap11.vue";

export default {
 
  data() {
    return {};
  },
  created(){
    
  },
  components: {
    Layout,
    map1
  }
};
</script>
<style lang="scss">
#app {
  height: 100%;
}
</style>
